module.exports = __webpack_public_path__ + "static/media/chemopharm.e76a1af9.svg";